import { useInterstateTheme } from '../../InterstateThemeProvider';
import { Box } from '../../Box';
import { REMOVE_TOAST } from '../Types/toastTypes';
import { keyframes } from '@emotion/react';
import { useContext, useEffect, useRef, useState } from 'react';
import { ToasterStoreContext } from './ToasterStoreContext';
import { Toast } from './Toast';
import { TOAST_TIMEOUT } from './store';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const fadeIn = keyframes`
    from {
        transform: translate3d(110%, 0, 0);
        visibility: visible;
        opacity: 0;
    }
    to {
        transform: translate3d(0, 0, 0);
        opacity: 1;
    }

`;
const fadeOut = keyframes`
  from {
    translateX(0%);
    visibility: visible;
  }
  to {
    transform: translateX(110%);
  }

`;
export const ToastContainer = props => {
  const {
    index,
    maxToasts,
    totalToasts,
    onClick,
    ...rest
  } = props;
  const theme = useInterstateTheme();
  const context = useContext(ToasterStoreContext);
  const [dismiss, setDismiss] = useState(false);
  const toastRef = useRef();
  const remove = useRef(false);
  const performAction = () => {
    if (remove.current) {
      context?.dispatch({
        type: REMOVE_TOAST,
        entry: {
          ...props
        }
      });
    }
  };
  useEffect(() => {
    toastRef.current?.addEventListener('animationend', performAction);
    return () => {
      toastRef.current?.removeEventListener('animationend', performAction);
    };
  });

  // Close the toast after 5 seconds
  useEffect(() => {
    setTimeout(() => {
      setDismiss(true);
      remove.current = true;
      if (rest.originToastId) {
        broadcastRemoveToast(rest.originToastId, rest.originContainerId, 'on_close');
      }
    }, TOAST_TIMEOUT);
  });
  const broadcastRemoveToast = (originToastId, originContainerId, action) => {
    if (!originToastId) {
      return;
    }
    rest.source.postMessage({
      type: REMOVE_TOAST,
      toastId: originToastId,
      containerId: originContainerId,
      action
    }, rest.origin);
  };
  const handleOnClose = event => {
    event.preventDefault();
    event.stopPropagation();
    setDismiss(true);
    remove.current = true;
    if (rest.originToastId) {
      broadcastRemoveToast(rest.originToastId, rest.originContainerId, 'on_close');
    }
    // dispatch message to remove toast
  };
  const handleOnClick = event => {
    event.preventDefault();
    event.stopPropagation();
    setDismiss(true);
    remove.current = true;
    if (onClick && !rest.originToastId) {
      onClick(event);
    }
    if (rest.originToastId) {
      broadcastRemoveToast(rest.originToastId, rest.originContainerId, 'on_click');
    }
  };
  // stop rendering toast after the max is exceeded
  if (index >= maxToasts) {
    return /*#__PURE__*/_jsx(Box, {
      display: 'none'
    });
  }
  return /*#__PURE__*/_jsxs(Box, {
    className: 'ids-toast-container',
    position: 'relative',
    sx: {
      animation: dismiss ? `${fadeOut} 0.25s 0.1s linear both ` : `${fadeIn} 0.5s 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both`
    },
    ref: toastRef,
    children: [/*#__PURE__*/_jsx(Toast, {
      ...rest,
      onClick: handleOnClick,
      handleOnClose: handleOnClose
    }), totalToasts > maxToasts && index === maxToasts - 1 && /*#__PURE__*/_jsx(Box, {
      className: 'ids-toast-first-stack-item',
      position: 'absolute',
      top: '8px',
      left: '8px',
      borderRadius: '4px',
      boxShadow: theme.tokens.BaseShadowMd,
      borderColor: theme.tokens.SemColorBorderMuted,
      sx: {
        backgroundColor: theme.tokens.SemColorSurfaceDefault,
        width: `${320 - 16}px`,
        minWidth: `${320 - 16}px`,
        maxWidth: `${320 - 16}px`,
        minHeight: '63px'
      },
      zIndex: 9,
      id: 'ids-toast-first-stack-id'
    }), totalToasts > maxToasts + 1 && index === maxToasts - 1 && /*#__PURE__*/_jsx(Box, {
      className: 'ids-toast-second-stack-item',
      position: 'absolute',
      top: '16px',
      left: '16px',
      borderRadius: '4px',
      boxShadow: theme.tokens.BaseShadowMd,
      borderColor: theme.tokens.SemColorBorderMuted,
      sx: {
        backgroundColor: theme.tokens.SemColorSurfaceDefault,
        width: `${320 - 32}px`,
        minWidth: `${320 - 32}px`,
        maxWidth: `${320 - 32}px`,
        minHeight: '63px'
      },
      zIndex: 8,
      id: 'ids-toast-second-stack-id'
    })]
  });
};